import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { func, number, bool } from 'prop-types';
import usePagination from './usePagination';
import { Content, Container } from './pagination.styles';
import PaginationItem from '../PaginationItem';
export default function Pagination(props) {
  const {
    items
  } = usePagination(props);

  function getAriaLabel(type, page, selected) {
    if (type === 'page') {
      return `${selected ? '' : 'Go to '}page ${page}`;
    }

    return `Go to ${type} page`;
  }

  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "aria-label": "pagination navigation"
  }), /*#__PURE__*/React.createElement(Content, null, items == null ? void 0 : items.map((item, index) => {
    const itemProps = Object.assign({}, item, {
      'aria-label': getAriaLabel(item.type, item.page, item.selected)
    });
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, /*#__PURE__*/React.createElement(PaginationItem, _extends({}, itemProps, {
      "data-testid": "pagination-item"
    })));
  })));
}
Pagination.defaultProps = {
  boundaryCount: 1,
  count: 1,
  disabled: false,
  page: 1,
  siblingCount: 1,
  onChange: () => {}
};
process.env.NODE_ENV !== "production" ? Pagination.propTypes = {
  boundaryCount: number,
  count: number,
  // total number of pages
  disabled: bool,
  page: number,
  // current page
  siblingCount: number,
  onChange: func // fired when page changed

} : void 0;